import { Tag, TagType, useTestIds } from "@homebound/beam";
import { TradePartnerTaskStatus } from "src/generated/graphqlTypes";
import { mapTradePartnerTaskStatusToReducedStatus, ReducedTradePartnerTaskStatus } from "src/utils";
import { ScheduleDraftMode_PlanTaskFragment } from "./ScheduleDraftMode.generated";

type DraftTradeStatusTagProps = { task: Pick<ScheduleDraftMode_PlanTaskFragment, "tradePartnerStatus"> };

/** The task's trade status, reduced to Not Sent, Pending or Confirmed. */
export function DraftTradeStatusTag(props: DraftTradeStatusTagProps) {
  const { task } = props;
  const tid = useTestIds(props, "tradeStatus");
  const { text, type } = tradeStatusTags[mapTradePartnerTaskStatusToReducedStatus(task.tradePartnerStatus.code)];
  return <Tag text={text} type={type} {...tid} />;
}

const tradeStatusTags: Record<ReducedTradePartnerTaskStatus, { text: string; type: TagType }> = {
  [TradePartnerTaskStatus.NotSent]: { text: "Not Sent", type: "error" },
  [TradePartnerTaskStatus.NeedsConfirmation]: { text: "Pending", type: "warning" },
  [TradePartnerTaskStatus.Confirmed]: { text: "Confirmed", type: "success" },
};
